import { Color } from '@repo/ui/components/GaugeChart/getConfig.js';

export const PRO_MSS_MESSAGES = {
  red: 'Multiple PRO metrics are out of range or significant concern is detected, indicating a need for support.',
  orange:
    'Some PRO metrics fall outside the expected range, suggesting areas for improvement.',
  grey: 'Most PRO metrics are within range, indicating an overall balanced gut.',
} satisfies Record<Color, string>;
